import styled from "styled-components";

export const Wrapper = styled.div`
    position: fixed;
    top: 60px;
    right: 10px;
    z-index: 2;
`;

// TODO Wrapper right

export const Opener = styled.div`
    width: 60px;
    height: 60px;
    background-color: ${p => p.theme.c.snow};
    border-radius: 30px;
    box-shadow: 0 0 4px 0 ${p => p.theme.c.blackShadow3};
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: relative;

    .i-messages {
        font-size: 40px;
        color: ${p => p.theme.c.active};
    }
`;

export const Notification = styled.div`
    position: absolute;
    bottom: 0;
    left: 0;
    background-color: ${p => p.theme.c.incorrect};
    width: 16px;
    height: 16px;
    border-radius: 8px;
`;

export const ChatWrapper = styled.div`
    background-color: ${p => p.theme.c.snow};
    border-radius: 8px;
    box-shadow: 0 0 4px 0 ${p => p.theme.c.blackShadow3};
    width: 300px;
`;

export const Header = styled.div`
    display: flex;
`;
export const Title = styled.div`
    flex: 1;
    line-height: 45px;
    padding: 0 8px;
    font-size: 20px;
    color: ${p => p.theme.c.greyA};
    font-weight: 600;
`;
export const Close = styled.div`
    cursor: pointer;
    font-size: 38px;
    line-height: 38px;
    width: 38px;
    height: 38px;
    text-align: center;
    color: ${p => p.theme.c.disabled};
`;

export const ChannelTitlesWrapper = styled.div`
    overflow-x: auto;
    white-space: nowrap;
    border-bottom: solid 1px ${p => p.theme.c.greyD};
    margin-top: -8px;
`;

export const ChannelTitle = styled.div`
    display: inline-block;
    color: ${p => p.theme.c.grey7};
    padding: 0;
    margin: 0 8px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;

    &.Active {
        color: ${p => p.theme.c.boost};
        border-bottom: 3px solid ${p => p.theme.c.boost};
    }
`;
